export default "__VITE_ASSET__DyiN4Rfr__"